module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.696df71a.woff2";